<template>
  <vs-row class="mt-1">
    <vs-col>
      <vs-pagination v-model="page" :total="totalPages" :max="7" />
    </vs-col>
  </vs-row>
</template>

<script>
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'

export default {
  name: 'PaginationProductList',
  computed: {
    totalPages() {
      return Math.ceil(ProductsFromCatalogStore.state.totalProducts / ProductsFromCatalogStore.state.perPage)
    },
    page: {
      get() {
        return ProductsFromCatalogStore.state.page
      },
      set(page) {
        ProductsFromCatalogStore.commit('setPage', page)
        ProductsFromCatalogStore.dispatch('getProductsFromCatalog')
      },
    },
  },
}
</script>

<style>
.vs-pagination--ul {
  margin-bottom: 0;
}
</style>
